import React from 'react';
import { findIndex, some } from 'lodash';
import Select from '../../../../components/input/Select';
import Input from '../../../../components/input/Input';
import CheckBox from '../../../../components/input/CheckBox';
import TableColumnImg from '../../../../components/table/TableColumnImg';
import Button from '../../../../components/Button';
import OpenBrandDetail from '../../../../components/link/OpenBrandDetail';
import { setDateFormat } from '../../../../lib/moment';
import {
  BRAND_TIER_LIST_STATUS,
  MAXIMUM_NUMBER_OF_TIER_ORDER_TEXT,
} from '../../../../constants/service/app/brandConstants';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';

/**
 * react-table v6 Cell 안정화를 위해 모듈 레벨에서 정의
 */
const CheckBoxCell = (row) => {
  const { selectedList, selectBrandTierItem, deselectBrandTierItem } = row.column;
  return (
    <CheckBox
      checked={some(selectedList[row.original.tier - 1], ['storeId', row.original.storeId])}
      disabled={row.original.listStatus === BRAND_TIER_LIST_STATUS.DELETED}
      onChange={(checked) => {
        if (checked) selectBrandTierItem(row.original);
        else {
          deselectBrandTierItem({
            storeId: row.original.storeId,
            tier: row.original.tier,
          });
        }
      }}
    />
  );
};

const TierSelectCell = (row) => {
  const { currentTierList, changeTierOnBrandTierList } = row.column;
  return (
    <Select
      list={currentTierList}
      disabled={row.original.listStatus === BRAND_TIER_LIST_STATUS.DELETED}
      onChange={(tier) => changeTierOnBrandTierList(tier, [row.original])}
      value={row.value}
      size="large"
    />
  );
};

const OrderNumberCell = (row) => {
  const { tier, newList, setData, changeNumberOnBrandTierList, scrollToBrandElement } = row.column;
  return (
    <div name={`tier_${tier}_no_${row.value}`} onClick={(e) => e.preventDefault()}>
      <Input
        type="number"
        size="large"
        maxLength={MAXIMUM_NUMBER_OF_TIER_ORDER_TEXT}
        value={row.value}
        disabled={row.original.listStatus === BRAND_TIER_LIST_STATUS.DELETED}
        onBlur={() => {
          if (row.index === row.value - 1) return;

          /**
           *  스크롤될 인덱스
           */
          let scrollIndex = 0;

          /**
           *  스크롤 최대 최소값 설정
           *  최대값으로 배열의 마지막 인덱스
           */
          if (newList[tier - 1].length - 1 < row.value) {
            scrollIndex = newList[tier - 1].length;
          } else if (row.value <= 0) {
            /**
             *  최솟값으로 배열의 마지막 인덱스
             */
            scrollIndex = 1;
          } else {
            /**
             *  순서를 변경하려는 곳의 인덱스를 구한다.
             */
            scrollIndex =
              findIndex(newList[tier - 1], (item, index) => index !== row.index && item.no === row.value) + 1;
          }

          /**
           *  순서변경
           */
          changeNumberOnBrandTierList(tier, row.index, scrollIndex - 1);

          /**
           *  순서변경된 곳으로 스크롤 이동
           */
          setTimeout(() => scrollToBrandElement(tier, scrollIndex), 1000);
        }}
        onChange={(value) => {
          setData({
            path: ['brandTierList', 'newList', tier - 1, row.index, 'no'],
            value: Number(value),
          });
        }}
      />
    </div>
  );
};

/**
 *  티어를 지정한 브랜드 테이블
 */
const columns = (data) => {
  const {
    tier,
    brandTierList,
    currentTierList,
    setData,
    selectBrandTierItem,
    deselectBrandTierItem,
    changeTierOnBrandTierList,
    changeNumberOnBrandTierList,
    scrollToBrandElement,
    deleteBrandTier,
  } = data;

  const { newList, selectedList } = brandTierList;

  return [
    {
      Header: () => <></>,
      selectedList,
      selectBrandTierItem,
      deselectBrandTierItem,
      Cell: CheckBoxCell,
    },
    {
      accessor: 'url',
      Header: '이미지',
      Cell: (row) => <TableColumnImg url={row.value} />,
    },
    {
      accessor: 'storeName',
      Header: '브랜드 명',
      Cell: (row) => <OpenBrandDetail text={`${row.value}(${row.original.storeId})`} storeId={row.original.storeId} />,
    },
    {
      accessor: 'confirmDate',
      Header: '입점일자',
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
    {
      accessor: 'tier',
      Header: '브랜드 티어',
      currentTierList,
      changeTierOnBrandTierList,
      Cell: TierSelectCell,
    },
    {
      accessor: 'no',
      Header: '순서',
      tier,
      newList,
      setData,
      changeNumberOnBrandTierList,
      scrollToBrandElement,
      Cell: OrderNumberCell,
    },
    {
      Header: '삭제',
      Cell: (row) => (
        <Button
          isRadius
          text={row.original.listStatus === BRAND_TIER_LIST_STATUS.DELETED ? '삭제취소' : '삭제'}
          color={row.original.listStatus === 'deleted' ? 'gray' : 'red'}
          onClick={() => {
            deleteBrandTier(row.original.tier, row.original.storeId);
          }}
        />
      ),
    },
  ];
};

export default columns;
